export const formatMusic = (abc) => {
	return `%%titlefont Kreon 24
%%subtitlefont Kreon 24
%%composerfont Helvetica italic
%%gchordfont "itim-music,Itim" 20
%%tempofont Helvetica
%%partsfont Helvetica
%%partsbox 1
%%annotationfont Helvetica-Oblique 10
${abc}
`;
};
